import { resolveMediaUrl } from '../../../../utils/mediaUrl'

function MemberChip({ member }) {
  if (member.type === 'count') {
    return (
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-primary bg-primary-container text-[10px] font-bold text-on-primary">
        {member.label}
      </div>
    )
  }

  if (!member.src) {
    const fallback = (member.label || member.alt || '?')
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join('')

    return (
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-primary bg-primary-container text-[10px] font-bold text-on-primary">
        {fallback || '?'}
      </div>
    )
  }

  return (
    <img
      alt={member.alt}
      className="h-8 w-8 rounded-full border-2 border-primary object-cover"
      src={resolveMediaUrl(member.src)}
    />
  )
}

export default function ContributionPointsCard({ points, change, trend, members }) {
  const isDown = trend === 'down'
  const isUp = trend === 'up'
  const iconName = isDown ? 'trending_down' : (isUp ? 'trending_up' : 'trending_flat')

  return (
    <article className="relative overflow-hidden rounded-lg bg-gradient-to-br from-primary to-primary-container p-6 text-on-primary">
      <div className="absolute inset-0 bg-gradient-to-br from-primary to-primary-container opacity-90" />

      <div className="relative z-10">
        <h3 className="mb-1 text-[11px] font-semibold uppercase tracking-wider text-blue-100/70">
          Contribution Points
        </h3>
        <div className="flex items-baseline gap-2">
          <p className="text-4xl font-black">{points}</p>
          <span className="inline-flex items-center gap-1 rounded bg-white/20 px-2 py-0.5 text-xs font-bold">
            <span className="material-symbols-outlined text-[10px]">{iconName}</span>
            {change}
          </span>
        </div>

        <div className="mt-6 flex -space-x-2">
          {members.map((member, index) => (
            <MemberChip key={`${member.type}-${index}`} member={member} />
          ))}
        </div>
      </div>
    </article>
  )
}
